import { useSponsoredContent } from "../useSponsoredContent"
import { ISponsoredContentResult } from "providers/venue/types"

interface IUseRecommendedPromotionResult {
  recommendedPromotions: ISponsoredContentResult
}

type IUseRecommendedPromotion = () => IUseRecommendedPromotionResult

export const useRecommendedPromotion: IUseRecommendedPromotion =
  (): IUseRecommendedPromotionResult => {
    const { recommendedPromotion: recommendedPromotions } =
      useSponsoredContent()

    return {
      recommendedPromotions,
    }
  }
